import css from "styled-jsx/css";

export const videoComponentStyles = css`
  .video-component {
    height: 100%;
    outline: none;
  }
`;
